import { inferRouterOutputs } from '@trpc/server';
import { AppRouter } from '@tagadapay/trpc-types';

import { trpc } from './trpc';

type OutputRouter = inferRouterOutputs<AppRouter>;

export type RecurringDiscountsSettings = OutputRouter['recurringDiscounts']['getSettings'];

export function useRecurringDiscountsSettings(storeId: string) {
  return trpc.recurringDiscounts.getSettings.useQuery({ storeId }, { enabled: !!storeId });
}

export function useUpdateRecurringDiscountsSettings() {
  const utils = trpc.useUtils();

  return trpc.recurringDiscounts.updateSettings.useMutation({
    onSuccess: () => {
      utils.recurringDiscounts.getSettings.invalidate();
    },
  });
}
